import { autoserialize } from 'cerialize';

export class FileData {

  @autoserialize
  filename: string;

  @autoserialize
  mimeType: string;

  @autoserialize
  blob: string;

  @autoserialize
  encoding: string;

  getDataURLString(): string {
    return `data:${this.mimeType};${this.encoding}, ${this.blob}`;
  }

  getArrayBufferFromBase64(): ArrayBufferLike {
    const binaryStr: string =  window.atob(this.blob);
    const len: number = binaryStr.length;
    const bytes: Uint8Array = new Uint8Array(len);
    for (let i = 0; i < len; i++)        {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes.buffer;
  }

}
